<template>
<svg viewBox="0 0 18 18" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-jiankongguanli`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_d9b24149c3__clip0_1284_117701)"><path fill-rule="evenodd" clip-rule="evenodd" d="M3 4.875V13.125H11.625V4.875H3ZM1.5 4.5C1.5 3.87868 2.00368 3.375 2.625 3.375H12C12.6213 3.375 13.125 3.87868 13.125 4.5V5.74198L15.4267 5.05146C16.1485 4.83491 16.875 5.37542 16.875 6.12901V11.871C16.875 12.6246 16.1485 13.1651 15.4267 12.9485L13.125 12.258V13.5C13.125 14.1213 12.6213 14.625 12 14.625H2.625C2.00368 14.625 1.5 14.1213 1.5 13.5V4.5ZM13.125 10.692L15.375 11.367V6.63302L13.125 7.30802V10.692ZM6.375 7.875H4.125V6.375H6.375V7.875Z"/></g><defs><clipPath id="svg_d9b24149c3__clip0_1284_117701"><path d="M0 0H18V18H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconJiankongguanli',
  props: {
    prefix: {
        type: String,
        default: 'zhilv',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
